import "../../styles/blocks/builder-page/builder-cta.scss";

import React from "react"
import PropTypes from "prop-types";

const BuilderCta = ({ text }) => {
	if (!text) {
		return null;
	}

	return (
		<div className="builder-cta">
			<div className="container container--medium">
				<div className="builder-cta__content">
					<p className="builder-cta__text">
						{text}
					</p>
				</div>
			</div>
		</div>
	);
};

BuilderCta.propTypes = {
	text: PropTypes.string
};

export default BuilderCta;
